export class ValidationResult {
    isSuccessful: boolean = null as unknown as boolean; 
    errorMessages: string[] = null as unknown as string[];

    public constructor({isSuccessful, errorMessages}: {isSuccessful: boolean, errorMessages: string[]}) {
        this.isSuccessful = isSuccessful;
        this.errorMessages = errorMessages;
    }
}